import type { ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import { baseColors } from "goi_common/src/design-system";

/** 하단 고정 버튼(위아래 두 개, 세로형)이 가리는 만큼 콘텐츠 아래에 두는 여백 */
export const QUESTION_BOTTOM_CTA_SPACE_VERTICAL = 160;

/**
 * 질문 화면 하단 고정 버튼 자리. 디자인 시스템 Bottom CTA(360x88, 위 40px 흰색 그라디언트)를 따른다.
 * 질문마다 버튼이 같은 자리에 있도록 모든 E5 질문 화면이 이걸 쓴다(2026-11-03 주완).
 */
export default function QuestionBottomCta({ children }: { children: ReactNode }) {
  return (
    <Box
      position="fixed"
      bottom={0}
      left="50%"
      transform="translateX(-50%)"
      width="100%"
      maxWidth="480px"
      padding="40px 20px 20px"
      background={`linear-gradient(to bottom, rgba(255,255,255,0) 0, ${baseColors.background_normal} 40px)`}
      zIndex={10}
    >
      {children}
    </Box>
  );
}
